import { useContext } from "react";
import { useTranslation } from "react-i18next";

import useResetAtomicState from "@hooks/useResetAtomicState";

import useAppStateSync from "@/hooks/useAppStateSync";
import { CheckoutContext } from "@/providers/context/CheckoutContext";

import { Button } from "@chakra-ui/react";

import { ClassesEnum } from "@ts/enums/ClassesEnum";

import internationalPremiumServicesImage from "@assets/img/international-premium-services.svg";

import ContentLayout from "@layouts/ContentLayout";

import { Skeleton } from "@components/Skeleton";

const InternationalPremiumServicesContainer = () => {
    const { t } = useTranslation();
    const checkoutContext = useContext(CheckoutContext);

    const { isProductFamiliesLoading } = checkoutContext;

    const { resetCheckoutAtomicState } = useResetAtomicState();

    const {
        state: { checkout: checkoutAppState },
        updateFlows: { resetCheckoutAppState }
    } = useAppStateSync();

    const onCancel = () => {
        resetCheckoutAtomicState();
        resetCheckoutAppState(
            checkoutAppState?.checkoutRedirectsTo ??
                route("parents.manage-programs")
        );
    };

    return (
        <>
            <img
                src={internationalPremiumServicesImage}
                alt={t(
                    "checkout.internationalPremiumServicesPage.title",
                    "Sorry, No premium services available"
                )}
                style={{ width: 260, margin: "48px auto -20px" }}
            />
            <ContentLayout
                className={ClassesEnum.MembershipContainer}
                containerWidth={[null, null, null, null]}
                title={t(
                    "checkout.internationalPremiumServicesPage.title",
                    "Sorry, No premium services available"
                )}
                description={t(
                    "checkout.internationalPremiumServicesPage.description",
                    "As you’re homeschooling internationally, our current premium services are not applicable or required for your location."
                )}
            >
                <Button
                    colorScheme="ebonyClay"
                    onClick={() => onCancel()}
                    width="max-content"
                    margin="auto"
                >
                    {t(
                        "checkout.internationalPremiumServicesPage.button",
                        "Got it, thanks"
                    )}
                </Button>
                {isProductFamiliesLoading && <Skeleton />}
            </ContentLayout>
        </>
    );
};
export default InternationalPremiumServicesContainer;
